import {Credentials, CredentialType} from "@/lib/types/credentials.ts";
import {
  CredentialProperties,
  GeneratedServiceVariableInput,
  ServiceVariableGroupByCredential,
} from "@/lib/types/serviceVariables.ts";

export const GetVariableNamesFromServiceVariableGroupByCredential = (
  serviceVariableGroupByCredential: ServiceVariableGroupByCredential[]
): string[] => {
  const variableNames: string[] = [];
  serviceVariableGroupByCredential.forEach((serviceVariableGroup) => {
    serviceVariableGroup.service_variables.forEach((serviceVariable) => {
      variableNames.push(serviceVariable.variable_name);
    });
  });
  return variableNames;
};

export const CreateCredentialServiceVariableInputsForCheck = (
  credential: Credentials,
  currentServiceVariablesVariableNames: string[]
): GeneratedServiceVariableInput[] => {
  return PartialServiceVariableFromCredentialType(credential, currentServiceVariablesVariableNames);
};

const CredentialPropertyVariableNamePrefix = (credential: Credentials, property: string): string => {
  let prefix = property;
  if (credential.credential_type === CredentialType.TOKEN && property === "secret") {
    prefix = "token";
  }
  return prefix;
};

const PartialServiceVariableFromCredentialType = (
  credential: Credentials,
  currentServiceVariablesVariableNames: string[]
): GeneratedServiceVariableInput[] => {
  const serviceVariableList: GeneratedServiceVariableInput[] = [];
  const possibleProperties = CredentialProperties[credential.credential_type];
  const properties = possibleProperties.filter((property) => credential.used_secret_properties.includes(property));
  if (credential.credential_type === CredentialType.BASIC && credential.username) {
    properties.push("username");
  }
  properties.sort(
    (a, b) =>
      CredentialProperties[credential.credential_type].indexOf(a) -
      CredentialProperties[credential.credential_type].indexOf(b)
  );
  properties.forEach((credential_property) => {
    const propertyPrefix = CredentialPropertyVariableNamePrefix(credential, credential_property);
    let escaped_display_name = credential.display_name.replace(/\s+/g, "_"); // Replace spaces with underscores
    escaped_display_name = escaped_display_name.replace(/[^a-zA-Z0-9_]/g, ""); // Remove all characters except letters, numbers, and underscores
    let variableName = `${propertyPrefix}_${escaped_display_name}`;
    let counter = 1;
    while (currentServiceVariablesVariableNames.includes(variableName)) {
      variableName = `${propertyPrefix}_${escaped_display_name}_${counter}`;
      counter++;
    }
    const serviceVariable: GeneratedServiceVariableInput = {
      credential_id: parseInt(credential.id),
      variable_name: variableName,
      property_name: credential_property,
    };
    serviceVariableList.push(serviceVariable);
  });
  return serviceVariableList;
};
